import React, {useCallback} from 'react'
import {Link as RouterLink, LinkProps} from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import {ROUTES} from '@/utils/routes'

const LinkBehavior = React.forwardRef<
    any,
    Omit<LinkProps, 'to'> & { href: LinkProps['to'] }
>((props, ref) => {
    const { href, ...other } = props
    // Map href (Material-UI) -> to (react-router)
    return <RouterLink ref={ref} to={href} {...other} />
})

LinkBehavior.displayName = 'LinkBehavior'

const datasetIdUnawarePaths = [ROUTES.HOME, ROUTES.DATA_INFO, ROUTES.JOBS_DATASET, ROUTES.NEW_DATASET, ROUTES.JOBS_DATABASE, ROUTES.NEW_DATABASE]

export default function Link(props: LinkProps) {

    const {to} = props
    const datasetId = new URLSearchParams(location.search).get('datasetId')

    const enhanceByDatasetId = useCallback(() => {
        if(to && datasetId) {
            let destination = to as string
            if(datasetIdUnawarePaths.includes(destination)){
                return to
            }

            if(destination && destination.includes('?')) {
                destination += `&datasetId=${datasetId}`
            } else {
                destination += `?datasetId=${datasetId}`
            }
            return destination
        }
        return to
    }, [to, datasetId])

    return <MuiLink component={LinkBehavior} {...{...props, href: enhanceByDatasetId(), to: enhanceByDatasetId()}} />
}
